import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchFromOldApi } from '~/services/Http';

import { LegalEntity } from './types';

export type StoreState = {
  legalEntities: LegalEntity[];
  hasData: boolean;
  isLoading: boolean;
  failedToLoad: boolean;
};

const initialState: StoreState = {
  legalEntities: [],
  hasData: false,
  isLoading: false,
  failedToLoad: false,
};

export enum LegalEntityActionKeyPrefixes {
  FETCH_LEGALENTITIES = 'legalEntities/FETCH_LEGALENTITIES',
}

export type LegalEntityPayload = {
  legalEntities: LegalEntity[];
};

const getLegalEntities = async (): Promise<LegalEntity[]> =>
  await fetchFromOldApi('/json/legalentity').then((r) => r.json());

export const fetchLegalEntities = createAsyncThunk<
  LegalEntityPayload,
  undefined
>(
  LegalEntityActionKeyPrefixes.FETCH_LEGALENTITIES,
  async (): Promise<LegalEntityPayload> => {
    return {
      legalEntities: await getLegalEntities(),
    };
  },
);

export const legalEntitySlice = createSlice({
  name: '~/data/legalEntities',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchLegalEntities.fulfilled.type]: (
      state: StoreState,
      action: PayloadAction<LegalEntityPayload>,
    ) => {
      state.failedToLoad = false;
      state.isLoading = false;
      state.hasData = true;
      state.legalEntities = action.payload.legalEntities;
    },
    [fetchLegalEntities.pending.type]: (state: StoreState) => {
      state.isLoading = true;
    },
    [fetchLegalEntities.rejected.type]: (state: StoreState) => {
      state.failedToLoad = true;
    },
  },
});

export const legalEntityReducer = legalEntitySlice.reducer;
